import { _ } from "core-js";
import Restraint from "oc-modules/oc-interaction/restraints2/Restraint";
import Maths3 from "oc-modules/oc-threejs/Maths3";
import { v3 } from "oc-modules/oc-threejs/short3";
import { GroundBox2dCollisionRestraint } from 'oc-modules/oc-interaction/restraints2/GroundBox2dCollisionRestraint';

export class InteriorRestraint extends GroundBox2dCollisionRestraint {
    accept() {
        return true;
    }

    onDrag3dBegin() {
        this.updateCollisionObjects();
        APP.arrangement.booth.interiors.forEach( i => i.resetColor());
        super.onDrag3dBegin();
    }

    onDrag3dEnd() {
        super.onDrag3dEnd();
    }
    
    updateCollisionObjects() {
        const objects = APP.arrangement.booth.interiors.filter(i=>i.jaco3d != this.dragObject3d).map(i => i.jaco3d);
        this.collisionObjectsUnfiltered = objects || [];
    }

    perform(raycaster, point, dropped) {
        const boothBox = APP.arrangement.booth.jaco3d.posbox.box;
        if(boothBox) {
            const oldValid = Object.assign({}, { value: this.dragObject3d.jaco.positionValid });
            const objectBox = this.getObjectBox(this.dragObject3d);
            const box = boothBox.clone();
            box.expandByVector(objectBox.getSize().multiplyScalar(-0.5));
            // point = box.clampPoint(point);
            this.dragObject3d.jaco.positionValid = (
                point.x >= box.min.x && point.x <= box.max.x &&
                point.z >= box.min.z && point.z <= box.max.z
            );

            if (oldValid.value !== this.dragObject3d.jaco.positionValid) {
                this.dragObject3d.onChangeInDragSelectHoverState();
            }
        }
        super.perform(raycaster, point, dropped);
    }
}